<template>
  <v-container
    ref="container"
    style="padding:0"
    class="fill-height page"
    fluid
  >
    <div class="overlay" />

    <v-row
      class="f-flex"
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <v-card class="elevation-12">
          <v-toolbar
            color="primary"
            dark
            flat
          >
            <v-toolbar-title>Nous y sommes presque</v-toolbar-title>
          </v-toolbar>
          <p class="pa-4">
            Votre demande de création de compte a bien été enregistrée.
            <br><br>
            Un email de confirmation vous a été envoyé pour terminer votre inscription et ainsi pouvoir participer aux différents concours du Calame d'or.
            <br>
            <br>
            Vous pouvez fermer cette page.<br>
            Merci et à bientôt
          </p>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    data: () => ({
    }),
    mounted () {
    },
  }
</script>

<style scoped>
.page {
  padding: 0!important;
  position: relative;
  background-position: center;
  background-size: cover;
  background-image: url('https://imaginary.service.codeisalie.fr/resize?height=80&url=https://storage.service.lecalamedor.fr/strapi/DSC_0173_5f06dace78.JPG');
}

.overlay {
  position: absolute;
  background: rgba(0, 0, 0, 0.7);
  height:100%;
  width:100%
}
</style>
